import {
  Typography,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
interface Props {
  method: "uploadFile" | "manual_input";
  setMethod: any;
}

const AddReceiptsMethodSelection = ({ method, setMethod }: Props) => {
  return (
    <>
      <Typography mb={2} variant="body1">
        You can add receipts in two ways: either upload a file directly or enter
        the details manually. <br />
        Choose the method that best fits your workflow.
      </Typography>
      <Typography variant="body1" fontWeight={500}>
        Receipt Creation Options
      </Typography>

      <FormControl sx={{ mt: 1 }}>
        <RadioGroup
          row
          value={method}
          onChange={(e) => setMethod(e.target.value)}
        >
          <FormControlLabel
            value="uploadFile"
            control={
              <Radio size="small" color="secondary" data-tracker="581" />
            }
            label="Upload a file"
          />
          <FormControlLabel
            value="manual_input"
            control={
              <Radio size="small" color="secondary" data-tracker="629" />
            }
            label="Manual input"
          />
        </RadioGroup>
      </FormControl>
    </>
  );
};

export default AddReceiptsMethodSelection;
